export const bulkRecallApiMode = (uiMode) => (uiMode === 'favorites' ? 'important' : uiMode);

export const bulkRecallMessagePayload = ({ body, mode, attachmentId, requestId }) => ({
  body: String(body || '').trim(),
  mode: bulkRecallApiMode(mode),
  delay_ms: 50,
  request_id: requestId,
  attachment_ids: attachmentId ? [attachmentId] : [],
});

const RECALL_IMAGE_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp', 'image/gif']);
const MAX_RECALL_IMAGE_BYTES = 8 * 1024 * 1024;

export const bulkRecallPhotoError = (file) => {
  if (!file || Number(file.size || 0) <= 0) return 'Choose a photo to attach.';
  if (!RECALL_IMAGE_TYPES.has(file.type)) return 'Choose a JPG, PNG, WEBP, or GIF photo.';
  if (file.size > MAX_RECALL_IMAGE_BYTES) return 'Photo must be 8 MB or smaller.';
  return '';
};

export const splitNewPlayerRooms = (rooms = []) => {
  const newPlayers = [];
  const conversations = [];
  rooms.forEach((room) => {
    (room?.newly_joined === true ? newPlayers : conversations).push(room);
  });
  return { newPlayers, conversations };
};
